// extracted by mini-css-extract-plugin
export default {"tabberWrap":"ContentTabs_tabberWrap__cBpqA","tabButton":"ContentTabs_tabButton__btJ4z","active":"ContentTabs_active__OJga7","themeGreen":"ContentTabs_themeGreen__lAgQo"};